import Contact from "../components/contact/Contact";
import Footer from "../components/footer/Footer";
import Header from "../components/Header";

const ContactRoute = () => {
  return (
    <>
      <Header />
      <Contact />
      <Footer />
    </>
  );
};
export default ContactRoute;
